import { CultureLocaleService } from './services/culture-locale.service';

export function AppIntializer(cultureLocaleService: CultureLocaleService) {
    return async () => await cultureLocaleService.initialise();
}